<section class="h-full flex flex-col gap-2 z-0 relative p-2 lg:pl-0">

  <!-- Top Controls -->
  <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2">
    <div class="flex gap-2">
      <button routerLink="add" class="btn btn-secondary">Add</button>
    </div>
    <div>
      <div *ngIf="services && services.length">
        <h1 class="text-xs text-nowrap text-left">
          Showing {{(numberOfRecords * currentPage) - (services.length != numberOfRecords?
          (numberOfRecords
          -services.length) : 0) }} of {{totalResults }} entries
        </h1>
      </div>
    </div>
    <div class="flex flex-col gap-4 sm:flex-row sm:gap-2">
      <div class="flex gap-2">
        <div class="relative">
          <input [(ngModel)]="search" (input)="onSearchInput()" type="text" required placeholder="Search.."
            class="pl-8" />
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
            class="absolute left-2 top-1/2 transform -translate-y-1/2 size-5">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
          </svg>
        </div>
      </div>
    </div>
  </div>

  <!-- Table Wrapper -->
  <div
    class="h-full overflow-hidden p-2 flex flex-col rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10">
    <div class="h-full w-full overflow-hidden rounded-md ring-1 ring-zinc-950/10 dark:ring-white/10">
      <div class="flow-root h-full overflow-y-auto">
        <div class="-my-2">
          <div class="inline-block min-w-full py-2 align-middle">
            <table class="min-w-full border-separate border-spacing-0">
              <thead>
                <tr>
                  <th class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 
                      text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">#</th>
                  <th class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 
                      text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">Action</th>
                  <th class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 
                      text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">Id</th>
                  <th class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 
                      text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">Name</th>
                  <th class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 
                      text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">Reference</th>
                  <th class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 
                      text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">Unit Price</th>
                  <th class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 
                      text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">Type</th>
                  <th class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 
                      text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">Used In</th>
                  <th class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 
                      text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">Taxable</th>
                  <th class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 
                      text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">Qty on hand</th>
                  <th class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 
                      text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">Income Account Name
                  </th>
                  <th class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 
                      text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">Income Account Value
                  </th>
                  <th class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 
                      text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">Status</th>
                </tr>
              </thead>
              <tbody>
                
                <tr *ngFor="let item of (services | paginate: { itemsPerPage:numberOfRecords, currentPage: currentPage, totalItems:totalResults}); let i=index"
                class="hover:bg-gray-950/5 dark:hover:bg-white/10">
                  <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">{{i + 1}}
                  </td>
                  <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    <div class="flex gap-2 items-center">

                      <div [appToolTip]="'Detail'" class="cursor-pointer" (click)="opendetailModal(item)">
                        <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                          <path d="M12 15a3 3 0 100-6 3 3 0 000 6z"></path>
                          <path clip-rule="evenodd" d="M1.323 11.447C2.811 6.976 7.028 3.75 12.001 3.75c4.97 0 9.185 
                            3.223 10.675 7.69.12.362.12.752 0 1.113-1.487 
                            4.471-5.705 7.697-10.677 7.697-4.97 
                            0-9.186-3.223-10.675-7.69a1.762 
                            1.762 0 010-1.113zM17.25 12a5.25 
                            5.25 0 11-10.5 0 5.25 5.25 0 
                            0110.5 0z" fill-rule="evenodd"></path>
                        </svg>
                      </div>

                      <a  [appToolTip]="'Edit'" routerLink="{{item.id}}/edit" class="hover:text-zinc-950 dark:hover:text-white text-zinc-500 dark:text-zinc-400"><svg
                          xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                          stroke="currentColor" class="size-5">
                          <path stroke-linecap="round" stroke-linejoin="round"
                            d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10">
                          </path>
                        </svg>
                      </a>

                      <div class="inline-flex relative">
                        <a [appToolTip]="'More Actions'" href="javascript:void(0)" (click)="showActionButtons(i)"
                          class="hover:text-zinc-950 dark:hover:text-white text-zinc-500 dark:text-zinc-400">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                            class="w-5 h-5">
                            <path stroke-linecap="round" stroke-linejoin="round"
                              d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z" />
                          </svg>
                        </a>
                        <div (outsideClick)="closeActionMenu($event)" outside-click *ngIf="selectedDropdownIndex === i && toggleActionButtons"
                          class="absolute left-4 z-20 my-4 w-64 origin-top-left rounded-md bg-white dark:bg-zinc-900 shadow-lg border border-zinc-950/10 hover:border-zinc-950/20 dark:border-white/10 dark:hover:border-white/20 focus:outline-none"
                          role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabindex="-1">
                          <app-qb-action-dropdown class="divide-y divide-zinc-950/10 dark:divide-white/10" [source]="'service'"
                            [service]="item" (pullFrom)="onSyncProductService(item.company.id, item.id, 'pull')"
                            (pushTo)="onSyncProductService(item.company.id, item.id, 'push')">
                          </app-qb-action-dropdown>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                   {{item.Id}}
                  </td>
                  <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                   {{((item.Name ) | titlecase)|| 'N/A'}}
                  </td>
                  <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                     <div class="flex flex-col gap-0.5 leading-tight">
                  <!-- reference Name -->
                  <span class="">
                    {{ ((item.reference?.name) | titlecase) || 'N/A'}}
                  </span>
                  
                  <!-- reference ID -->
                  <span  class="text-[12px] text-blue-400 bg-blue-50 px py-0.5 rounded-md w-fit font-mono tracking-wide">
                    {{((item.reference?.id).slice(0, 8)) || 'N/A' }} <span *ngIf="item.reference?.type">({{ item.reference?.type}})</span>
                  </span>
                  </div>
                  </td>
                  <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                   {{item.UnitPrice || 'N/A'}}
                  </td>
                  <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    {{((item.Type)| titlecase) || 'N/A'}}
                  </td>
                  <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    <div class="flex gap-1">
                      <span *ngIf="item.IncomeAccountRef?.value" class="badge-primary">Invoice</span>
                      <span *ngIf="item.ExpenseAccountRef?.value" class="badge-warning">Bill</span>
                      <span *ngIf="!item.IncomeAccountRef?.value && !item.ExpenseAccountRef?.value">N/A</span>
                    </div>
                  </td>
                  <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    {{ item?.Taxable == null ? 'N/A' : (item.Taxable ? 'Yes' : 'No') }}
                  </td>
                  <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                   {{item.QtyOnHand || 'N/A'}}
                  </td>
                  <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                   <span *ngIf="item.IncomeAccountRef">   {{((item.IncomeAccountRef.name) | titlecase) || 'N/A'}}</span>
                  </td>
                  <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                 <span *ngIf="item.IncomeAccountRef">   {{item.IncomeAccountRef.value || 'N/A'}}</span>
                  </td>
                  <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    <span [ngClass]="item.status == 'created' ? 'badge-primary' : 'badge-success'">{{(item.status | titlecase) || 'N/A'}}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
      <div class="flex justify-end">
      <pagination-controls (pageChange)="onPageChange($event)" class="pagination-controls"></pagination-controls>
    </div>
  </div>
</section>

<app-service-detail-modal *ngIf="serviceDetail" [serviceDetail]="serviceDetail"
    (closeModal)="serviceDetail = null"> </app-service-detail-modal>